module.exports = __webpack_public_path__ + "static/react-wpm-f306cca704f8f9df41dfbde28fdaad9e.png";